export default "__VITE_ASSET__DKiRmyM1__"